import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';

const DishesInStopCheckBox: React.FC = () => {
	const { isDisabledDish, IDSelectedCustomer, IDSelectedRestaurant, toggleDisabledDishes } =
		useContext<IDishesContext>(DishesContext);

	return (
		<Checkbox
			checked={isDisabledDish}
			onChange={toggleDisabledDishes}
			disabled={!IDSelectedCustomer || !IDSelectedRestaurant}
			data-test="DisabledDishesCheckBox">
			<Text translationNameSpace="listing" translationKey="dishInStopLabel" asFragment={true} />
		</Checkbox>
	);
};

export default DishesInStopCheckBox;
